import styles from '../style/style';

class Styles {
  constructor() {
    this.init();
  }

  init() {
    const hasInjectedStyle = document.querySelector('style[id="signature-digital"]');
    const head = document.getElementsByTagName('head')[0];
    
    if (!hasInjectedStyle) {
      head.insertAdjacentHTML('beforeend', styles)
    }
  }
}

export default Styles;